import React from 'react';
import { OptionsPrixa, InputOptionsPrixa, DivOptionsPrixa } from './style';

export interface OptionsProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  data: {
    id: string | number;
    nameIndo?: string;
    name: string;
  };
  setData: any;
  selected: any;
}

const OptionsButton = (props: { data: any; setData: any; selected: any }) => {
  return (
    <div className="flex-inline margin-smallT">
      {props &&
        props.data &&
        props.data.map((item: any) => {
          return (
            <OptionsPrixa key={item.id}>
              <InputOptionsPrixa
                type="radio"
                name="radio-btn"
                checked={
                  JSON.stringify(props.selected) === JSON.stringify(item)
                }
                value={item.id}
                onChange={() => {
                  props.setData(item);
                }}
              />
              <DivOptionsPrixa>{item.nameIndo || item.name}</DivOptionsPrixa>
            </OptionsPrixa>
          );
        })}
    </div>
  );
};

export default OptionsButton;
